import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiServiceService } from '../../services/common/api-service.service';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';
import { Location } from '@angular/common';
@Component({
  selector: 'app-shortlisted-merchants',
  templateUrl: './shortlisted-merchants.component.html',
  styleUrls: ['./shortlisted-merchants.component.scss']
})
export class ShortlistedMerchantsComponent implements OnInit {

  ownerProfileId: string = '';

  shortlistedMerchants: any[] = [];
  apiUrl = environment.apiUrl;

  loading: boolean = false;
  cities: any[] = [];
  categories: any[] = [];
  

  constructor(
    private apiService: ApiServiceService,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit(): void {

    this.ownerProfileId =
      localStorage.getItem('profileId') || '';

    if (!this.ownerProfileId) {
      console.warn('Owner profile ID not available');
      return;
    }

    this.loadShortlistedMerchants();
     this.loadCities();
     this.loadCategories();
  }
    goBack(): void {
  this.location.back();
}

  loadShortlistedMerchants(): void {

    this.loading = true;

    this.apiService
      .getShortlistedMerchants(this.ownerProfileId)
      .subscribe({

        next: (response: any) => {

          console.log(
            'Shortlisted Merchants Page Response:',
            response
          );

          this.shortlistedMerchants =
            response.data || [];

          this.loading = false;

        },

        error: (error) => {

          console.error(
            'Error loading shortlisted merchants:',
            error
          );

          this.shortlistedMerchants = [];

          this.loading = false;

        }

      });
  }

  removeShortlist(merchant: any): void {

    const merchantId = merchant?.merchant?._id;

    if (!merchantId) {
      console.error(
        'Merchant ID not found:',
        merchant
      );
      return;
    }

    this.apiService
      .removeShortlistedMerchant(
        this.ownerProfileId,
        merchantId
      )
      .subscribe({

        next: (response: any) => {

          console.log(
            'Merchant removed:',
            response
          );

          this.shortlistedMerchants =
            this.shortlistedMerchants.filter(
              item => item?.merchant?._id !== merchantId
            );

          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'Removed from shortlist',
            showConfirmButton: false,
            timer: 2000
          });

        },

        error: (error) => {

          console.error(
            'Error removing merchant:',
            error
          );

          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title: 'Could not remove merchant',
            showConfirmButton: false,
            timer: 2000
          });

        }

      });
  }

  viewMerchant(merchantId: string): void {

    this.router.navigate([
      '/wedding-services/merchant',
      merchantId
    ]);

  }
  getMerchantImage(merchant: any): string {

  const profilePic = merchant?.profile_pic;

  if (!profilePic) {
    return 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&w=600&q=80';
  }

  if (profilePic.startsWith('/')) {
    return this.apiUrl + profilePic;
  }

  return profilePic;
}
loadCities(): void {

  this.apiService.getMerchantCities().subscribe({

    next: (response: any) => {
      this.cities = response.data || [];
    },

    error: (error) => {
      console.error('Error loading cities:', error);
      this.cities = [];
    }

  });
}
getCityName(cityId: string): string {

  if (!cityId) {
    return 'Location not specified';
  }

  const city = this.cities.find(
    (item: any) =>
      String(item._id) === String(cityId)
  );

  return city?.city_nme || 'Location not specified';
}
loadCategories(): void {

  this.apiService.getServiceCategories().subscribe({

    next: (response: any) => {

      console.log('Service Categories:', response);

      this.categories = response.data || [];

    },

    error: (error) => {

      console.error(
        'Error loading service categories:',
        error
      );

      this.categories = [];
    }

  });
}
getCategoryName(categoryId: string): string {

  if (!categoryId) {
    return 'Wedding Service';
  }

  const category = this.categories.find(
    (item: any) =>
      String(item._id) === String(categoryId)
  );

  return (
    category?.name ||
    category?.category_name ||
    category?.category_nme ||
    'Wedding Service'
  );
}
}